import {Component, OnInit, Input} from '@angular/core';
import {UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';
import {InsertionCycle} from '@app/shared/models/insertion-cycle.model';
import {PartNumber} from '@app/shared/models/partNumber.model';
import {InsertionCyclesService} from '@app/core/services/insertion-cycles.service';
import {Log} from 'ng2-logger';
import * as _ from 'lodash';

@Component({
    selector: 'app-part-number-insertion-cycles-form',
    templateUrl: './part-number-insertion-cycles-form.component.html',
    styleUrls: ['./part-number-insertion-cycles-form.component.scss']
})
export class PartNumberInsertionCyclesFormComponent implements OnInit {
    _logger = Log.create(PartNumberInsertionCyclesFormComponent.name);

    @Input() insertionCycles: InsertionCycle[] = [];
    @Input() showValidations;
    @Input() isSpi = false;
    @Input() mode: string;

    isLoading = false;
    get isFormValid() {
        return this.insertionCyclesForm.valid;
    }

    public partNumber: PartNumber;
    public insertionCyclesForm: UntypedFormGroup;

    constructor() {
    }

    ngOnInit() {
        this.insertionCyclesForm = new UntypedFormGroup({
            'insertionCycles': new UntypedFormControl({value: [], disabled: this.isSpi}),
        })
    }

    public init(partNumber: PartNumber) {
        if (partNumber) {
            this.partNumber = partNumber;
            this.isSpi = partNumber.lines.some(x => x.isSPI);
        }
        if (!this.isSpi) {
            this.insertionCycles = [];
            this.insertionCyclesForm.controls['insertionCycles'].setValue([]);
        }
    }

    public getFormDetails() {
        this._logger.info("getFormInsertionCycles::", this.partNumber);
        const formData = this.insertionCyclesForm.getRawValue();
        return formData;
    }

    public resetForm() {
        this._logger.info("resetForm:: Resetting part number details form", this.partNumber);
        this.insertionCyclesForm.reset();
    }

    public setForm(insertionCycles: {insertionCycles: InsertionCycle[]}) {
        this.insertionCyclesForm.setValue(insertionCycles);
    }

    public isReadOnly() {
        return this.mode === 'view';
    }

}
